import * as React from 'react';
import { useBeforeunload } from 'react-beforeunload';

import { LandingBlock } from '../../components/LandingBlock';
import { ContentWrapper } from '../../components/ContentWrapper';
import { BlockHeader } from '../../components/BlockHeader';
import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { trackCalculatorBlockShow, trackAnyClickOnCalculator, trackSendFormFromCalculator } from './tracking';

import * as styles from './styles.css';
import { CalculatorComponent } from '../../components/CalculatorComponent';

export const FIN_CALCULATOR_STATE_STORAGE_KEY = 'calculatorState';

export const removeFinCalcStateFromLocalStorage = () => {
  localStorage.removeItem(FIN_CALCULATOR_STATE_STORAGE_KEY);
};

export const FinCalculator = () => {
  useBeforeunload(removeFinCalcStateFromLocalStorage);

  const onSendFormButtonClick = () => {
    trackSendFormFromCalculator();

    const $anchor = document.getElementById('second-form') as HTMLElement;
    const offsetTop = $anchor.getBoundingClientRect().top + window.pageYOffset;

    window.scroll({
      top: offsetTop,
      left: 0,
      behavior: 'smooth',
    });
  };

  return (
    <ElementInViewport onVisibleFirst={trackCalculatorBlockShow}>
      <div className={styles['fin-container']} onClick={trackAnyClickOnCalculator}>
        <LandingBlock>
          <ContentWrapper>
            <BlockHeader>Начните решение ипотечного вопроса</BlockHeader>
            <CalculatorComponent onSendFormButtonClick={onSendFormButtonClick} />
          </ContentWrapper>
        </LandingBlock>
      </div>
    </ElementInViewport>
  );
};
